import { render, staticRenderFns } from "./EventPassedContent.vue?vue&type=template&id=acd18c52"
import script from "./EventPassedContent.vue?vue&type=script&lang=ts"
export * from "./EventPassedContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports